import "./styles.css";
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuthContext } from "../../context/authContext";
// import { usePermissao } from "../../Hooks/usePermissao";
import AuthGuard from "../AuthGuard";
import { ETipoPermissao } from "../../Enum/Enum";
//import Logo from "../../Imagens/logo_icon.png";
import Logo from "../../Imagens/logoPentagov.jpg";

import { BsFillPersonVcardFill, BsCardChecklist } from "react-icons/bs";
import { AiFillProfile } from "react-icons/ai";
import { IoIosPaper } from "react-icons/io";
// import { GrDocumentUpload } from "react-icons/gr";
import { HiBriefcase } from "react-icons/hi";
import { FaAngleDown, FaAngleUp, FaUserPlus, FaUsersCog, FaPowerOff, FaClipboardCheck, FaList } from "react-icons/fa";

const MenuLateral = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [cadastrosAberto, setCadastrosAberto] = useState(false);
  const [submenuOperador, setSubmenuOperador] = useState(false);
  const [auditoriaAberto, setAuditoriaAberto] = useState(false);
  const navigate = useNavigate();

  const { operador, authReady, logout } = useAuthContext();
  // const { possuiTipo } = usePermissao();

  const toggleSubmenuOperador = () => {
    setSubmenuOperador(!submenuOperador);
  };

  const canSeeAuditoria =
    operador?.permissaoPrincipal === 99 ||
    operador?.cargos?.some((c) => c.descricao === "Gerente Auditoria");


  useEffect(() => {
    if (!operador && !authReady) {
      navigate("/");
    }
  }, [operador]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleCadastros = () => {
    setCadastrosAberto(!cadastrosAberto);
  };

  const toggleAuditoria = () => {
    setAuditoriaAberto(!auditoriaAberto);
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="menu-container">
      <div className="menu-toggle" onClick={toggleMenu}>
        <span className="menu-icon"></span>
        <span className="menu-icon"></span>
        <span className="menu-icon"></span>
      </div>

      <nav className={`sidebar ${isOpen ? "open" : ""}`}>
        <div id="logoMenu">
          <img id="imgLogo" src={Logo} alt="Logo Pentagrama" />
          {/* <br />
          <label style={{ paddingTop: "10px", color: "white", fontWeight: "bold", fontSize: "20px", width: '100%', textAlign: 'center' }}>
            PentaGOV
          </label> */}
        </div>
        <ul id="listamenu">
          <li><Link to="/Menu"><BsFillPersonVcardFill className="iconesMenu" />Clientes</Link></li>

          {/* Cadastros com subitens */}
          {/* {user.cargos[0].descricao === "Administrador" && ( */}

          {/* ###### Usando Hook usePermissao ###### */}
          {/* {!possuiTipo(ETipoPermissao.ADMIN) && ( */}
          <AuthGuard tipoPermissao={ETipoPermissao.ADMIN}>
            <li id="lista_cadastro" onClick={toggleCadastros}>
              <AiFillProfile className="iconesMenu" />
              Cadastros {cadastrosAberto ? <FaAngleUp id="arrowSubmenus" /> : <FaAngleDown id="arrowSubmenus" />}
            </li>
            {cadastrosAberto && (
              <ul style={{ listStyle: 'none', paddingLeft: '25px' }}>
                <li><Link to="/CadCargo"><HiBriefcase className="iconesMenu" />Cargos</Link></li>
                <li><Link to="/CadOperador"><FaUserPlus className="iconesMenu" />Operadores</Link></li>
                <li><Link to="/CadCliente"><BsFillPersonVcardFill className="iconesMenu" />Clientes</Link></li>
                <li id="lista_cadastro" onClick={toggleSubmenuOperador}>
                  <FaUsersCog className="iconesMenu" />Operador x Clientes
                  {submenuOperador ? (
                    <FaAngleUp id="arrowSubmenus" />
                  ) : (
                    <FaAngleDown id="arrowSubmenus" />
                  )}
                </li>

                {submenuOperador && (
                  <ul style={{ listStyle: "none", paddingLeft: "25px" }}>
                    <li>
                      <Link to="/CadOperadorProcesso">
                        <FaUsersCog className="iconesMenu" />Por Operador
                      </Link>
                    </li>

                    <li>
                      <Link to="/CadProcessoOperador">
                        <FaUsersCog className="iconesMenu" />Por Cliente
                      </Link>
                    </li>
                  </ul>
                )}

                <li><Link to="/CadastroPlanejamento"><BsFillPersonVcardFill className="iconesMenu" />Planejamento</Link></li>
                <li><Link to="/aprovexterno"><FaUsersCog className="iconesMenu" />Aprovar Cad. Externo</Link></li>
                {/* Adicione outros cadastros conforme necessário */}
              </ul>
            )}
          </AuthGuard>
          {canSeeAuditoria && (
            <>
              <li id="lista_cadastro" onClick={toggleAuditoria}>
                <FaClipboardCheck className="iconesMenu" style={{ fontSize: 18 }} />
                Auditoria {auditoriaAberto ? <FaAngleUp id="arrowSubmenus" /> : <FaAngleDown id="arrowSubmenus" />}
              </li>

              {auditoriaAberto && (
                <ul style={{ listStyle: 'none', paddingLeft: '25px' }}>
                  {/* <li><Link to="/Auditoria"><FaList className="iconesMenu" style={{ fontSize: 22 }} />Seções</Link></li> */}
                  <li><Link to="/AuditoriaQuestao"><IoIosPaper className="iconesMenu" style={{ fontSize: 22 }} />Questões</Link></li>
                  {/* <li><Link to="/AuditoriaChecklist/1"><BsCardChecklist className="iconesMenu" style={{ fontSize: 22 }} />Checklist</Link></li> */}
                  <li><Link to="/AuditoriaOperadorSecao"><FaUsersCog className="iconesMenu" style={{ fontSize: 22 }} />Operador x Seções</Link></li>
                </ul>
              )}
            </>
          )}

          <li id="lista_cadastro" onClick={handleLogout}>
            <FaPowerOff className="iconesMenu" />Sair
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default MenuLateral;
